import styled, { css } from 'styled-components';

export const MessageNicoleWrapper = styled.div`
    display: flex;
    height: 28px;
    margin-right: 16px;
    width: 28px;

    img {
        width: 100%;
    }
`;

export const MessageAvatarWrapper = styled.div`
    margin-right: 16px;
    position: relative;
    width: 28px;
`;

export const MessageCustomAvatarImage = styled.img(
    ({ theme: { radius } }) => css`
        border-radius: ${radius['50']}%;
        height: 26px;
        margin: 0;
        position: relative;
        right: -1px;
        top: 1px;
        width: 26px;
        z-index: 99;
    `,
);

export const MessageSpeekiLogoIcon = styled.div`
    height: 26px;
    margin: 0;
    position: relative;
    right: -6px;
    top: 6px;
    width: 26px;
    z-index: 99;
`;
